import autobind from "autobind-decorator";
import Transition from "./Transition";
import Boom from "./nav-click";
class Nav {
	init() {
		/* register click animation*/
		Boom.init('#boom');

		console.log('up');

		$('body').on('click','.data-send-ue-cart, .quantity_change',function(){

			//console.log('clicked send');
			window.setTimeout(function(){
                $.ajax({
                    method: 'GET',
                    url: wp_ajaxurl,
                    data: {
                        action: 'send_cart_data_to_UE'
                    }
                })
                    .done(function(response){
                        console.log(response);
                    });
			},2000);
		});

		const treshold = 280;
		this.lastScroll = $(window).scrollTop();
		this.isScrolling = false;
		this.isHidden = false;
		this.isOpenSlide = false;
		this.$nav = $("header.nav-wrap");
		let t = new Transition(this.$nav);
		let hasPopped = false;
		$(document).ready(() => {
			this.$wrap = $(".nav-user-slide-wrap");

			if ($(window).width() <= breakpoints.large) {

				$('.menu-item-has-children').each(function () {
					let trigger = $(this).find('>a'),
						sub = $(this).find('.sub-menu');
					trigger.click(function () {
						sub.toggleClass('open');
						return false;
					});
				});

			}
			else {

				$("header .open-login").click(this.openSlide);
				$("header .open-register").click(this.openSlide);

			}

			$('button.hamburger').click(function (e) {
				$('.nav_main').toggleClass('open');
			});

			if (0 && $(window).width() > breakpoints.large) {
				$(window).scroll(() => {

					const y = $(window).scrollTop();
					const goingDown = y > this.lastScroll;
					const belowTreshold = y > treshold;

					if (belowTreshold) {
						hasPopped = false;
						t.pop('is-popped', 0);
						t.push('is-scrolling');
						if (goingDown) {
							t.pop('is-visible');
							this.closeSlide();
						} else {
							t.push('is-visible');
						}
						t.pop('scrolling', 0);
					} else if (!hasPopped) {
						hasPopped = true;
						t.push('is-popped', 0);
						t.pop('is-visible').then(() => {
							this.$nav[0].offsetHeight;
							t.pop('is-scrolling', 0);

						}, () => {
							this.$nav[0].offsetHeight;
							t.pop('is-scrolling', 0);
						});
					}
					this.lastScroll = y;
				}).scroll();
			}

			//$(".nav").on('click', Boom.boom);
			$(".logo_wrap")
				.on('click', Boom.boom)
				.on('click', (ev) => {
					if (document.body.classList.contains('home')) {
						$("html,body").animate({scrollTop: 0}, 500);
						ev.preventDefault();
					}
				});
			setTimeout(() => {
				window.addEventListener('resize', this.handleResize);
				this.handleResize();
			});


			let bg = document.querySelector('#login-backdrop');
			bg.addEventListener('click', this.closeSlide)
		});
	}

	@autobind
	handleResize() {
		let $cur = $("header .menu-item.current-menu-item");
		if ($cur.length > 0) {
			$cur = $cur.children('a');
			const padding = 0;//parseInt($cur.css('padding-left'));
			const $i = $("header .indicator");
			setTimeout(() => {
				$i.css('transform', 'none');
			});
			$i.css({
				left: $cur.offset().left + padding + 'px',
				width: ($cur.width() - padding * 2) + 'px',
				display: "block"
			});
		}
	}

	@autobind
	openSlide(ev) {
		ev.preventDefault();
		if (this.isOpenSlide) {
			//return;
		}
		this.isOpenSlide = true;
		let openLogin = ev.delegateTarget.classList.contains('open-login');
		let hasLogin = $(".nav-user-slide").hasClass('login-active');
		let hasActive = this.$wrap.hasClass('is-active');
		let bg = document.querySelector('#login-backdrop');
		if (hasActive && hasLogin == openLogin) {
			this.closeSlide();
			return;
		}
		document.body.classList.add('login-active');
		bg.offsetHeight;
		setTimeout(function () {
			bg.style.opacity = 1;
		}, 0);
		this.$wrap.addClass("is-active");
		if (openLogin) {
			$(".nav-user-slide").addClass('login-active');
		} else {
			$(".nav-user-slide").removeClass('login-active');
		}
		$("body").on('scroll', this._checkScroll);
	}

	@autobind
	closeSlide() {
		if (!this.isOpenSlide) {
			return;
		}
		this.isOpenSlide = false;
		let bg = document.querySelector('#login-backdrop');
		this.$wrap.removeClass('is-active');
		bg.style.opacity = 0;
		bg.offsetHeight;
		setTimeout(function () {
			document.body.classList.remove('login-active');
		}, 200);
	}

	@autobind
	_checkScroll() {
		if (window.scrollY > this.$wrap.height()) {
			this.closeSlide();
		}
	}
}
export default new Nav();



// WEBPACK FOOTER //
// ./assets/js/nav.js